import { ProfileType } from "@/constants/profile";
import type { Profile } from "@/types/profile";
import { convertAllDatesToEst, formatShortDateIgnoreTz, typedObjectEntries } from "@/utils";
import type { PREFERENCE_LABELS } from "@/utils/consts";

export const profileToDataModel = (profile: Profile) => {
  const profileWithEstDates = convertAllDatesToEst(profile, [
    "createdAt",
    "emailsEnabledAt",
    "smsEnabledAt",
  ]);

  const preferences = typedObjectEntries(profile?.preferences ?? {}).reduce(
    (acc, [key, value]) => {
      acc[key] = typedObjectEntries(value ?? {})
        .filter(([, v]) => {
          return v;
        })
        .map(([k]) => {
          return k;
        });

      return acc;
    },
    {} as Record<keyof typeof PREFERENCE_LABELS, string[]>,
  );

  return {
    ...profileWithEstDates,
    birthDate: profile.birthDate ? formatShortDateIgnoreTz(profile.birthDate) : null,
    isCaregiver: profile.type === ProfileType.caregiver,
    avoidedPreferences: preferences,
  };
};
